import { createContext } from 'react';
import initialCatalogCsvUploadState from './initialCatalogCsvUploadState';

const CatalogCsvUploadContext = createContext(initialCatalogCsvUploadState);

export default CatalogCsvUploadContext;
